export default "__VITE_ASSET__Dq9yhICV__"